// extracted by mini-css-extract-plugin
module.exports = {"carousel":"RoomListItem_carousel__9RbqM","textWrapper":"RoomListItem_textWrapper__5Bvw0"};